module.exports = __webpack_public_path__ + "static/media/window-minimize.e4747aa2.svg";